module.exports = __webpack_public_path__ + "sz.cca48a3ee010369af2b3.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/sz.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/sz.svg
// module chunks = styles